/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Goal } from '../models/Goal';
import type { Patient } from '../models/Patient';
import type { PatientGoalsUpdate } from '../models/PatientGoalsUpdate';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PatientsService {
    /**
     * Get Patients
     * Get all patients.
     * @returns Patient Successful Response
     * @throws ApiError
     */
    public static getPatientsApiPatientsGet(): CancelablePromise<Array<Patient>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/patients/',
        });
    }
    /**
     * Create Patient
     * Create a new patient.
     * @returns Patient Successful Response
     * @throws ApiError
     */
    public static createPatientApiPatientsPost({
        requestBody,
    }: {
        requestBody: Patient,
    }): CancelablePromise<Patient> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/patients/',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Patient
     * Get a single patient by ID.
     * @returns Patient Successful Response
     * @throws ApiError
     */
    public static getPatientApiPatientsPatientIdGet({
        patientId,
    }: {
        patientId: number,
    }): CancelablePromise<Patient> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/patients/{patient_id}',
            path: {
                'patient_id': patientId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Patient
     * Update an existing patient.
     * @returns Patient Successful Response
     * @throws ApiError
     */
    public static updatePatientApiPatientsPatientIdPut({
        patientId,
        requestBody,
    }: {
        patientId: number,
        requestBody: Patient,
    }): CancelablePromise<Patient> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/patients/{patient_id}',
            path: {
                'patient_id': patientId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Patient
     * Delete a patient.
     * @returns any Successful Response
     * @throws ApiError
     */
    public static deletePatientApiPatientsPatientIdDelete({
        patientId,
    }: {
        patientId: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/patients/{patient_id}',
            path: {
                'patient_id': patientId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Patient Goals
     * Get all goals for a specific patient.
     * @returns Goal Successful Response
     * @throws ApiError
     */
    public static getPatientGoalsApiPatientsPatientIdGoalsGet({
        patientId,
    }: {
        patientId: number,
    }): CancelablePromise<Array<Goal>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/patients/{patient_id}/goals',
            path: {
                'patient_id': patientId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Patient Goals
     * Update patient goals (replaces all existing goals).
     * @returns any Successful Response
     * @throws ApiError
     */
    public static updatePatientGoalsApiPatientsPatientIdGoalsPut({
        patientId,
        requestBody,
    }: {
        patientId: number,
        requestBody: PatientGoalsUpdate,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/patients/{patient_id}/goals',
            path: {
                'patient_id': patientId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
